import * as actions from '@actions';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import useAuth from '@vl-core/useAuth';
import type { Response as ClinicianResponse } from 'vl-common/src/schemas/getCliniciansClinicians';

export function useClinician() {
  const dispatch = useDispatch();
  const { user } = useAuth();

  const { data, isLoading } = useQuery<ClinicianResponse>({
    queryKey: ['getClinician', user?.user_guid],
    queryFn: () => dispatch(actions.getClinician(user!.user_guid)),
    placeholderData: { clinicians: [] },
    enabled: !!user
  });

  const clinician = data?.clinicians?.[0];

  return { clinician, isLoading };
}

export default useClinician;
